<template>
  <div class="chinaEuropeTrain">
    <Header :typeHeader="'defaultHeader'">
      <!-- banner -->
      <img slot="headerImage" :src="imgList.bannerImg" alt="" />
      <!-- 标题 -->
      <div slot="headerTitle">{{ $store.state.navShow == true ? '国际贸易' : 'International trade' }}</div>
      <div style="
          font-size: 1.125rem;
          color: #ffffff;
          font-weight: 100;
          margin-top: 0.6rem;
        " slot="headerTitle">
        {{ $store.state.navShow == true ? '构架更高的国际视野 创造无界的服务价值' : 'import and export trade service provider for global customers'}}
      </div>
    </Header>
    <div class="TopTitle" data-aos="fade-right">
      <!-- data-aos="fade-up-left" -->
      <div class=""> {{ $store.state.navShow == true ? $route.name : $route.meta.EnName }} </div>
    </div>
    <!-- fade-down -->
    <div class="ContentText" data-aos="slide-right">
      <p>
        {{ $store.state.navShow == true ?
        'MG集团贸易主业在能源、粮食、肉类、大宗商品等领域，深耕俄罗斯本土贸易供应链优势，提供的优质产品和专业服务广泛应用于社会生产和衣食住行，在国内外享有良好声誉。' : "MG Group's main trade business is in the fields of energy, grain, meat, bulk commodities and so on.It has dug deeply the advantages of ussia's local trade supply chain.The high - quality products and professional services it provides are widely used in social production, clothing, food, housing and transportation, and enjoy a good reputation at home and abroad."}}
      </p>
    </div>
    <div class="ContentCustomer">
      <!-- <div class="internationalTradeImg">
				<p class="tableTitleTitle">MG集团与俄罗斯政府和龙头企业深度合作</p>
				<img class="internationalTradeImg01" src="../../assets/internationalTrade/internationalTradeImg01.jpg">
			</div> -->
      <!-- <div class="internationalTradeImg">
				<p data-aos="fade-right">俄罗斯最大的三家超市的供货商X5零售集团</p>
				<img class="internationalTradeImg01" src="../../assets/internationalTrade/internationalTradeImg02.jpg"
					data-aos="fade-right">
			</div> -->
      <!-- <div class="internationalTradeImg">
				<p data-aos="fade-right">俄罗斯肉食龙头塞尔那维雅、布莱恩斯基等企业</p>
				<img class="internationalTradeImg01" src="../../assets/internationalTrade/internationalTradeImg03.jpg"
					data-aos="fade-right">
			</div> -->
      <!-- <div class="internationalTradeImg">
				<p data-aos="fade-right">白俄罗斯进口泥炭土，用于农业种植和改良土壤环境</p>
				<img class="internationalTradeImg01" src="../../assets/internationalTrade/internationalTradeImg04.jpg"
					data-aos="fade-right">
			</div> -->
      <!-- <p class="tableTitleTitle4" data-aos="fade-right">贸易对接</p> -->
      <div class="Docking">
        <img class="DockingImage" v-for="(item, index) in ttList" :key="index" data-aos="fade-right" :src="item.image"
          alt="" />
        <!-- <div class="DockingList" v-for="(item,index) in DockingList" :key="index" data-aos="fade-right">
					<img class="DockingListImg" :src="item.icon" :style="'width:' + item.iconW +'px;'">
					<div class="DockingListText">
						{{ item.title }}
					</div>
				</div> -->
      </div>
      <!-- 商务服务 -->
      <div class="ContentText" data-aos="slide-right">
        <p>
          {{ $store.state.navShow == true ?
          'MG集团是中俄贸易供应链领跑者，服务于对俄出口方向的中国企业超过1000家。2021年4月至今，外贸货品交易额超100种品类，其中机械电子、电气设备、皮毛制品、服装鞋帽、车辆配件外贸出口总量超过146万件，贸易总额超过14亿元。致力将进出口贸易与海外资源相链接，打造国际贸易闭环，加速国际贸易流通。' : 'MG                  Group is a leader in the Sino - Russian trade supply chain, with more than 1000 Chinese enterprises serving the export direction to Russia.Since April 2021, the trade volume of foreign trade goods has exceeded 100 categories, including machinery and electronics, electrical equipment, fur products, clothing, shoes and hats, vehicle accessories, with a total export volume of more than 1.46 million pieces, and a total trade volume of more than 1.4 billion yuan.We are committed to linking import and export trade with overseas resources, creating a closed loop of international trade and accelerating international trade circulation.'}}
        </p>
      </div>
      <div class="introduce" :style="$store.state.navShow == true ? 'height: 11.25rem' : 'height: 18.25rem'">
        <img v-if="$store.state.navShow == true" src="../../assets/internationalTrade/tt.jpg" alt="" />
        <img v-else src="../../assets/internationalTrade/ttE.jpg" alt="" />
        <div class="introduceCon">
          <div class="introduceConIn">
            <div class="introduceConInTop">
              <div class="introduceConInTopOne">
                <countTo :startVal='0' :endVal='1000' :duration='3000'></countTo>
              </div>
              <div class="introduceConInTopTwo">{{ $store.state.navShow == true ? '家' : '' }}</div>
            </div>
            <div class="introduceConInBut">
              {{ $store.state.navShow == true ? '服务于对俄出口方向中国企业超' : 'Serving over Chinese enterprises exporting to Russia'}}
            </div>
          </div>
          <div class="introduceConIn">
            <div class="introduceConInTop">
              <div class="introduceConInTopOne">
                <countTo :startVal='0' :endVal='100' :duration='3000'></countTo>
              </div>
              <div class="introduceConInTopTwo">{{ $store.state.navShow == true ? '种' : '' }}</div>
            </div>
            <div class="introduceConInBut">
              {{ $store.state.navShow == true ? '外贸货品交易额超' : 'Over kinds of foreign trade goods'}}
            </div>
          </div>
          <div class="introduceConIn">
            <div class="introduceConInTop">
              <div class="introduceConInTopOne">
                <countTo :startVal='0' :endVal='146' :duration='3000'></countTo>
              </div>
              <div class="introduceConInTopTwo">{{ $store.state.navShow == true ? '万件' : '' }}</div>
            </div>
            <div class="introduceConInBut">
              {{ $store.state.navShow == true ? '外贸出口量超' : 'Foreign trade export volume exceeded'}}
            </div>
          </div>
          <div class="introduceConIn">
            <div class="introduceConInTop">
              <div class="introduceConInTopOne">
                <countTo :startVal='0' :endVal='14' :duration='3000'></countTo>
              </div>
              <div class="introduceConInTopTwo">{{ $store.state.navShow == true ? '亿元' : '' }}</div>
            </div>
            <div class="introduceConInBut">
              {{ $store.state.navShow == true ? '货品交易额超' : 'The transaction volume of goods exceeds '}}
            </div>
          </div>
        </div>
      </div>

      <div class="jzxBox">
        <p class="tableTitleTitle5">{{ $store.state.navShow == true ? '集装箱贸易' : 'Container trade' }}</p>
        <div class="jzxBox_cont_1" data-aos="fade-right">
          <div class="jzxBox_cont_1_title">
            {{ $store.state.navShow == true ? 'MG集团在中俄主要城市提供集装箱的出租及收箱业务截至2023年6月' : 'MG Group provides container leasing and collection business in major cities in China and Russia'}}
            <div class="jzxBox_cont_1_title_1" v-if="$store.state.navShow != true">As of June 2023</div>
          </div>
          <div class="jzxBox_cont_1_two">
            <div class="jzxBox_cont_1_two_1">
              <div class="jzxBox_cont_1_two_1_one">
                {{ $store.state.navShow == true ? '94000' : '80,000'}}<span> TEU</span>
              </div>
              <div class="jzxBox_cont_1_two_1_two">
                {{ $store.state.navShow == true ? '集装箱干箱及冷箱交易达' : 'with container trading and leasing transactions amounting to'}}
              </div>
            </div>
            <div class="jzxBox_cont_1_two_1" v-if="$store.state.navShow == true">
              <div class="jzxBox_cont_1_two_1_one"> 10000 <span>TEU</span></div>
              <div class="jzxBox_cont_1_two_1_two">
                {{ $store.state.navShow == true ? '集装箱租赁交易近' : 'MG Group provides container leasing and collection business in major cities in China and Russia'}}
              </div>
            </div>
          </div>
          <div class="jzxBox_cont_1_three">
            {{ $store.state.navShow == true ? '团队拥有多年从事国际多式联运业务，集装箱租赁业务运营及境内外堆场代理业务经验。' : 'Our team has many years of experience in international multimodal transportation, container leasing business operations and domestic and international yard agency business.'}}
          </div>
        </div>
        <div class="jzxBox_cont_2" data-aos="fade-right">
          <div class="jzxBox_cont_2_img">
            <img src="@/assets/internationalTrade/t5.png" class="jzxBox_cont_2_img" alt="">
            <div>
              {{ $store.state.navShow == true ? '箱量充足且箱况良好' : 'Plenty of containers in good condition'}}
            </div>
          </div>

          <div class="jzxBox_cont_2_title">
            {{ $store.state.navShow == true ? '每月可提供全国1000-2000台集装箱。' : 'We can provide 1,000-2,000 containers per month nationwide.'}}
          </div>
        </div>
        <div class="jzxBox_cont_2" data-aos="fade-right">
          <div class="jzxBox_cont_2_img">
            <img src="@/assets/internationalTrade/t6.png" class="jzxBox_cont_2_img" alt="">
            <div>
              {{ $store.state.navShow == true ? '提箱及还箱点多' : 'Lots of pickup and return points'}}
            </div>
          </div>

          <div class="jzxBox_cont_2_title">
            {{ $store.state.navShow == true ? '国内主要港口均设有提箱点，还箱点分布俄罗斯热门还箱地，与多个境内外堆场合作，为客户提供多种租赁模式的定制化集装箱租赁服务。' : 'There are pick-up points in all major domestic ports, return points are distributed in popular return places in Russia, and we cooperate with many domestic and foreign yards to provide customers with customized container leasing services in a variety of leasing modes.'}}
          </div>
        </div>
      </div>


      <div class="ButTextCon">
        <div class="ButTextConTitle">
          {{ $store.state.navShow == true ? '应对新变化 创造新价值' : 'Respond to new changes and create new value'}}
        </div>
        <div class="ButTextConText">
          {{ $store.state.navShow == true ?
          'MG集团将架构国际间外贸流通新渠道、新生态，以迸发社会经济共生动力，推动区域经济社会实现可持续增长。' : 'MG Group will build a new channel and new ecology for international foreign trade circulation so as to stimulate the power of social and economic symbiosis and to promote the sustainable growth of the regional economy and society.'}}
        </div>
        <!-- <div class="ButTextConText">
          以迸发社会经济共生动力，推动区域经济社会实现可持续增长。
        </div> -->
      </div>
      <!-- <div class="ContentCustomer">
				<div class="ContentTopImg" data-aos="fade-right">
					<img src="../../assets/businessServices/ContentTopImg.png">
				</div>
				<p class="tableTitleTitle5">交流活动</p>
				<div class="communication">
					<div class="communication_One">
						<img src="../../assets/businessServices/communication01.jpg">
					</div>
					<div class="communication_Two" data-aos="fade-right">
						<img src="../../assets/businessServices/communication02.jpg">
						<img src="../../assets/businessServices/communication03.jpg">
					</div>
					<div class="communication_One" data-aos="fade-right">
						<img src="../../assets/businessServices/communication04.jpg">
					</div>
					<div class="communication_Two" data-aos="fade-right">
						<img src="../../assets/businessServices/communication05.jpg">
						<img src="../../assets/businessServices/communication06.jpg">
					</div>
					<div class="communication_Two" data-aos="fade-right">
						<img src="../../assets/businessServices/communication07.jpg">
						<img src="../../assets/businessServices/communication08.jpg">

					</div>
					<div class="communication_One" data-aos="fade-right">
						<img src="../../assets/businessServices/communication09.jpg">
					</div>
					<div class="communication_Two" data-aos="fade-right">
						<img src="../../assets/businessServices/communication010.jpg">
						<img src="../../assets/businessServices/communication011.jpg">
					</div>
				</div>
			</div> -->
      <!-- <div class="bannerCons" data-aos="fade-up">
				<div class="showCon1">
					<div class="showConTop">
						<el-row type="flex" justify="space-between" class="showConTopImg" :gutter="10">
							<el-col :span="6" v-for="(item, index) in showConImgList.list0.top" :key="index">

								<img :src="item.img" @click="JupmPath(item.path)">
							</el-col>
						</el-row>
					</div>
					<div class="showConbBtton">
						<el-row type="flex" class="showConTopImg" :gutter="20">
							<el-col :span="21">
								<img class="showConBttonImg_1" :src="showConImgList.list0.img5.img"
									@click="JupmPath(showConImgList.list0.img5.path)">
							</el-col>
							<el-col :span="10">
								<img class="showConBttonImg_2" :src="showConImgList.list0.img6.img"
									@click="JupmPath(showConImgList.list0.img6.path)">
							</el-col>
							<el-col :span="10">
								<img class="showConBttonImg_3" :src="showConImgList.list0.img7.img"
									@click="JupmPath(showConImgList.list0.img7.path)">
							</el-col>
						</el-row>
					</div>
				</div>
			</div> -->
    </div>
    <div class="buttonImgIT">
      <img src="../../assets/internationalTrade/dada.png" />
      <!-- <img :src="imgList.currency"> -->
    </div>
  </div>
</template>

<script>
  import Header from "@/components/header.vue";
  import countTo from 'vue-count-to';
  export default {
    components: {
      Header,
      countTo
    },
    data() {
      return {
        DockingList: [{
            icon: require("@/assets/internationalTrade/icon_01.png"),
            title: "进出口贸易对接",
            iconW: "32",
          },
          {
            icon: require("@/assets/internationalTrade/icon_02.png"),
            title: "采购商与供应商精准匹配",
            iconW: "28",
          },
          {
            icon: require("@/assets/internationalTrade/icon_03.png"),
            title: "境外展会、交流活动对接",
            iconW: "29.5",
          },
          {
            icon: require("@/assets/internationalTrade/icon_04.png"),
            title: "国内产业聚集区对接",
            iconW: "26.5",
          },
        ],

        ttList: [{
            image: require("@/assets/internationalTrade/t1.jpg"),
          },
          {
            image: require("@/assets/internationalTrade/t2.jpg"),
          },
          {
            image: require("@/assets/internationalTrade/t3.jpg"),
          },
          {
            image: require("@/assets/internationalTrade/t4.jpg"),
          },
        ],
        imgList: {
          bannerImg: require("@/assets/internationalTrade/bfj.jpg"),
          // backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
          // currency: require('@/assets/OverseasWarehouse/currency.png'),
          bottonImg: require("@/assets/OverseasWarehouse/currency.png"),
        },
        showConImgList: {
          list0: {
            top: [{
                img: require("@/assets/header/business1.png"),
                title: "海运服务",
                path: "/CR_oceanShipping",
              },
              {
                img: require("@/assets/header/business2.png"),
                title: "汽车运输",
                path: "/CR_automobileTransportation",
              },
              {
                img: require("@/assets/header/business3.png"),
                title: "空运服务",
                path: "/CR_airServices",
              },
              // {
              //   img: require("@/assets/header/business4.png"),
              //   title: "中俄清关",
              //   path: "/CR_customsClearance",
              // },
              {
                img: require("@/assets/header/business15.png"),
                title: '境外承运',
                path: ''
              },
            ],
            img5: {
              img: require("@/assets/header/business5.png"),
              title: "中欧运输",
              path: "/chinaEuropeTrain",
            },
            img6: {
              img: require("@/assets/header/business6.png"),
              title: "国际贸易",
              path: "/internationalTrade",
            },
            img7: {
              img: require("@/assets/header/business7.png"),
              title: "中欧班列境外服务商",
              path: "/CR_overseasServiceProvider",
            },
          },
        },
      };
    },
    methods: {
      /**
       * 跳转
       * 罗锦炜
       * 2021-12-08
       * */
      JupmPath(path) {
        console.log(this.$router.history.current.fullPath);
        if (path == this.$router.history.current.fullPath) {
          document.documentElement.scrollTop = 0;
        } else {
          this.$router.push({
            path: path,
          });
        }
      },
    },
  };
</script>
<!-- 头部 -->
<style lang="less">
  .chinaEuropeTrain {
    background-color: #ffffff;
  }

  .TopTitle {
    width: 92%;
    height: 4.95rem;
    position: relative;
    margin: 0 4%;
    top: -3.2rem;
    border-bottom: 1px solid rgba(204, 204, 204, 0.5);

    &>div {
      position: absolute;
      top: 1.25rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      padding: 1.2rem 3.375rem 1.2rem 0.75rem;
      background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, 0.15), hsla(0, 0%, 100%, 0.15));
    }
  }

  .ButTextCon {
    margin-top: 2rem;

    .ButTextConTitle {
      font-size: 1.2rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #2e67b1;
      margin-bottom: 0.8rem;
    }

    .ButTextConText {
      font-size: .8rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2e67b1;
      text-align: center;
      text-align: justify;
    }
  }

  .introduce {
    position: relative;
    width: 100%;
    height: 11.25rem;

    .introduceCon {
      width: 60%;
      // height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // align-items: center;
      padding: 1.5rem 0 1rem 1.5rem;

      .introduceConIn {
        width: 45%;

        .introduceConInTop {
          display: flex;
          align-items: flex-end;

          .introduceConInTopOne {
            font-size: 1.3rem;
            font-family: AkzidenzGroteskBQ;
            font-weight: normal;
            color: #ffffff;
            margin-right: 0.5rem;
          }

          .introduceConInTopTwo {
            font-size: 0.5rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin-bottom: 0.1rem;
          }
        }

        .introduceConInBut {
          font-size: 0.8rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          margin-top: 0.4rem;
          text-align: left;
        }
      }
    }
  }

  .ContentText {
    width: 92%;
    margin: 0 4%;
    // background-color: #000066;
    margin-top: -1.575rem;
    text-align: left;

    &>p {
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      text-indent: 2em;
      margin-bottom: 1.25rem;
      text-align: justify;
    }
  }
</style>

<style lang="less">
  @z: 0.5px;

  .ContentCustomer {
    width: 92%;
    margin: 0 4%;
    margin-top: 2.25rem;

    .internationalTradeImg {
      margin-bottom: 1.875rem;

      &>p {
        // margin: 1.875rem 0 0.625rem 0;
        font-size: 0.79rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2e67b1;
        text-align: left;
        margin-bottom: 0.9375rem;
      }

      &>img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .Docking {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 3rem;

    .DockingImage {
      width: 48%;
      height: 13rem;
      margin-bottom: 1rem;
    }

    .DockingList {
      width: 48.5%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
      margin-bottom: 0.625rem;

      .DockingListImg {
        // width: 2rem;
        height: 2.765625rem;
        margin-top: 0.7625rem;
      }

      .DockingListText {
        width: 85%;
        font-size: 0.6875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-bottom: 0.71875rem;
      }
    }
  }

  .bannerCons {
    width: 100%;
    // height: 332px * @z;
    margin-bottom: 61 * @z;

    img {
      border-radius: 3px;
    }

    .showCon1 {
      width: 100%;
      margin-bottom: 20 * @z;
      // padding: 0 32 * @z;

      .showConTop {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-bottom: 10px;

        .showConTopImg {
          width: 100%;
          height: 156 * @z;
        }
      }

      .showConbBtton {
        width: 100%;
        display: flex;
        justify-content: space-around;

        .showConTopImg {
          width: 100%;
          height: 156 * @z;

          img {
            height: 78px;
          }

          .el-col {
            padding-left: 5px !important;
            padding-right: 5px !important;
          }

          .el-col-21 {
            width: 85% !important;
          }
        }
      }
    }
  }

  // 小标题
  .tableTitleTitle4 {
    // margin: 1.875rem 0 0.625rem 0;
    font-size: 0.79rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2e67b1;
    text-align: left;
    margin-bottom: 0.9375rem;
  }

  .buttonImgIT {
    width: 100%;
    height: 7.5rem;
    // z-index: -1;

    &>img {
      width: 100%;
      height: 100%;
    }
  }
</style>
<style lang="less">
  .ContentText {
    width: 92%;
    margin: 0 4%;
    margin-top: -1.575rem;
    text-align: left;

    &>p {
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      text-indent: 2em;
      margin-bottom: 1.25rem;
    }
  }

  .ContentCustomer {
    width: 92%;
    margin: 0 4%;
    margin-top: 2.25rem;

    .ContentTopImg {
      width: 100%;
      margin-bottom: 0.625rem;

      &>img {
        width: 100%;
        height: 100%;
      }
    }

    .communication {
      width: 100%;
      margin-bottom: 45px;

      &>div {
        width: 100%;
        margin-bottom: 0.525rem;
      }

      .communication_One {
        width: 100%;
      }

      .communication_Two {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &>img {
          width: 49%;
        }
      }
    }
  }

  .tableTitleTitle5 {
    // margin: 1.875rem 0 0.625rem 0;
    font-size: 0.95rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2e67b1;
    text-align: left;
    margin-bottom: 0.9375rem;
  }

  .jzxBox {
    padding: 2.1333rem 0 0;

    .jzxBox_cont_1 {
      flex: 1;
      padding: 1.3333rem;
      background: #2D6AAB;
      margin-bottom: 1.0667rem;

      >div {
        text-align: left;
      }

      .jzxBox_cont_1_title {
        font-size: .4267rem;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 1.0667rem;

        .jzxBox_cont_1_title_1 {
          margin-top: .5333rem;
        }
      }

      .jzxBox_cont_1_two {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1.6533rem;

        .jzxBox_cont_1_two_1 {
          width: 50%;

          .jzxBox_cont_1_two_1_one {
            font-size: 1.0667rem;
            font-weight: bold;
            color: #FFFFFF;

            >span {
              font-size: .5333rem;
              font-weight: 400;
            }
          }

          .jzxBox_cont_1_two_1_two {
            font-size: .5333rem;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }

      .jzxBox_cont_1_three {
        font-size: .4267rem;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 1.0133rem;
      }
    }

    .jzxBox_cont_2 {
      background-color: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
      display: flex;
      flex-direction: column;
      margin-bottom: 1.0667rem;

      .jzxBox_cont_2_img {
        height: 5.8667rem;
        position: relative;

        >img {
          width: 100%;
          height: 100%;
        }

        >div {
          font-size: .64rem;
          font-weight: bold;
          color: #FFFFFF;
          position: absolute;
          bottom: .5333rem;
          left: .1333rem;
          right: .1333rem;
          text-align: center;
        }
      }

      .jzxBox_cont_2_title {
        flex: 1;
        padding: 1.0667rem 1.0667rem;
        font-size: .64rem;
        font-weight: 400;
        color: #666666;
        line-height: 1.0133rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>